import React, { useEffect, useState } from "react";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import {
  dynamicFieldDelete,
  dynamicFieldManage,
} from "../../../../services/applicationFormService";
import { toast } from "react-toastify";
import DeleteModal from "../../../common/DeleteModal";
import FileUploadSingle from "../../../form/FileUploadSingle";

const SchoolPaymentInfo = ({
  backHandeler = () => {},
  continueHandler = () => {},
  close = () => {},
  data,
  details,
  loaded,
  stepsSlug,
  setLoaded = () => {},
  values,
  handleChange,
  errors,
  setFieldsValue,
  formValidate,
}) => {
  const [savedData, setSavedData] = useState({});
  const [fieldConfigs, setFieldConfigs] = useState([]);
  const [addingField, setAddingField] = useState(false);
  const [newFieldType, setNewFieldType] = useState("");
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [showUploadInputs, setShowUploadInputs] = useState([]);
  useEffect(() => {
    if (data) {
      setLoaded(true);
      setFieldConfigs(
        data?.data?.map((item) => ({
          ...item,
          fieldType: item?.type || "Input",
          label: item?.label || "",
          placeholder: item?.placeholder || "",
          isRequired: item?.isRequired || false,
          file: item?.uploadFile?.url || "",
          uploadButtonText: item?.uploadButtonText || "",
          options:
            ["Select", "Radio"].includes(item?.type) &&
            Array.isArray(item?.options)
              ? item.options.map((opt) => opt.label || opt.value || "")
              : undefined,
        })) || []
      );
      setLoaded(false);
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (updatedField) => {
      const isSelectOrRadio = ["Select", "Radio"].includes(
        updatedField?.fieldType
      );
      const payload = {
        formId: details._id,
        groupCode: stepsSlug,
        primaryId: updatedField?._id,
        label: updatedField?.label,
        placeholder: updatedField?.placeholder,
        isRequired: updatedField?.isRequired,
        type: updatedField?.fieldType,
      };

      if (isSelectOrRadio) {
        payload.options = (updatedField?.options || []).map((val) => ({
          label: val,
          value: val,
        }));
        payload.isMultiple = updatedField?.fieldType === "Select";
      }
      if (updatedField?.file) {
        payload.uploadFile = updatedField.file;
        payload.uploadButtonText = updatedField.uploadButtonText;
      }
      return await dynamicFieldManage(payload);
    },
    onSuccess: (res) => {
      toast.success(res?.message);
    },
    onError: (error) => {
      console.error("Mutation error:", error);
    },
  });

  const handleFieldChange = (index, key, value) => {
    const updated = [...fieldConfigs];
    updated[index][key] = value;
    setFieldConfigs(updated);
  };

  const handleSaveField = (index) => {
    const updatedField = fieldConfigs[index];
    setSavedData({ updatedField });

    if (setFieldsValue) {
      setFieldsValue({ updatedField });
    }

    mutate(updatedField);
  };

  const handleAddField = (type) => {
    const newField = {
      fieldType: type,
      label: "",
      placeholder: "",
      isRequired: false,
      options: ["", ""],
      groupCode: details?.steps?.length > 0 && details?.steps?.[0],
    };
    setFieldConfigs((prev) => [...prev, newField]);
    setAddingField(false);
    setNewFieldType("");
  };
  const handleDeleteField = (index) => {
    const fieldToDelete = fieldConfigs[index];
    if (!fieldToDelete?._id) {
      setFieldConfigs((prev) => prev.filter((_, idx) => idx !== index));
    } else {
      setDeleteModal({
        isOpen: true,
        data: fieldToDelete,
      });
    }
  };
  const { mutate: handleDeleteApi, isPending: deletePending } = useMutation({
    mutationFn: async (fieldData) => {
      const res = await dynamicFieldDelete({
        primaryId: fieldData._id,
        formId: fieldData.formId,
        groupCode: fieldData?.groupCode,
      });
      return { res, fieldData };
    },
    onSuccess: ({ res, fieldData }) => {
      if (res?.status === 200 || res?.status === 201) {
        setDeleteModal({ isOpen: false, data: null });
        setFieldConfigs((prev) =>
          prev.filter((field) => field._id !== fieldData._id)
        );
        toast.success(res?.message);
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.error("Delete error:", error);
      toast.error("Failed to delete field.");
    },
  });
  const handleUploadClick = (index) => {
    setShowUploadInputs((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <>
      {!loaded ? (
        <div>
          {fieldConfigs.map((field, i) => (
            <div key={i} className="p-4 rounded-lg shadow border bg-white mb-4">
              <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
                <Select
                  label="Field Type"
                  placeholder="Type"
                  selectedValue={field.fieldType}
                  dropdownData={[
                    { name: "Input", value: "Input" },
                    { name: "Email", value: "Email" },
                    { name: "Input", value: "Input" },
                    { name: "Email", value: "Email" },
                    { name: "TextArea", value: "TextArea" },
                    { name: "InputNumber", value: "InputNumber" },
                    { name: "Url", value: "Url" },
                    { name: "DatePicker", value: "DatePicker" },
                    { name: "Select", value: "Select" },
                    { name: "Radio", value: "Radio" },
                    { name: "File", value: "File" },
                    { name: "Checkbox", value: "Checkbox" },
                  ]}
                  setSelectedValue={(val) =>
                    handleFieldChange(i, "fieldType", val)
                  }
                />

                <Input
                  label="Label"
                  placeholder="Field Label"
                  value={field.label}
                  onChange={(e) =>
                    handleFieldChange(i, "label", e.target.value)
                  }
                />

                {field.fieldType !== "Radio" && (
                  <Input
                    label="Placeholder"
                    placeholder="Enter placeholder"
                    value={field.placeholder}
                    onChange={(e) =>
                      handleFieldChange(i, "placeholder", e.target.value)
                    }
                  />
                )}

                <Select
                  label="Required?"
                  placeholder="Select"
                  selectedValue={field.isRequired ? "true" : "false"}
                  dropdownData={[
                    { name: "True", value: "true" },
                    { name: "False", value: "false" },
                  ]}
                  setSelectedValue={(val) =>
                    handleFieldChange(i, "isRequired", val === "true")
                  }
                />

                <div className="mt-auto w-full md:w-1/4 flex gap-2">
                  <Button
                    buttonLabel="Save"
                    buttonType="button"
                    buttonClasses="!rounded !px-8 !h-10 !bg-chestnut-rose !text-white"
                    buttonFunction={() => handleSaveField(i)}
                  />
                  <Button
                    buttonLabel=""
                    buttonType="button"
                    buttonIcon="fa-regular fa-trash-can"
                    buttonIconPosition="left"
                    buttonClasses="!bg-chestnut-rose !text-white !text-sm !rounded !px-5 !h-10"
                    buttonFunction={() => handleDeleteField(i)}
                  />
                </div>
              </div>

              {["Select", "Radio"].includes(field?.fieldType) && (
                <div className="mt-4 space-y-2">
                  <p className="font-medium text-sm text-gray-700">Options</p>

                  {(field?.options || []).map((opt, optIdx) => (
                    <div key={optIdx} className="flex items-center gap-2">
                      <Input
                        placeholder={`Option ${optIdx + 1}`}
                        value={opt}
                        onChange={(e) => {
                          const updatedOptions = [...field?.options];
                          updatedOptions[optIdx] = e.target.value;
                          handleFieldChange(i, "options", updatedOptions);
                        }}
                      />
                      <Button
                        buttonLabel=""
                        buttonType="button"
                        buttonIconPosition="left"
                        buttonIcon="fa-regular fa-trash"
                        buttonClasses="!bg-red-500 !text-white !text-sm !rounded !px-3 !py-1"
                        buttonFunction={() => {
                          const updatedOptions = field?.options?.filter(
                            (_, idx) => idx !== optIdx
                          );
                          handleFieldChange(i, "options", updatedOptions);
                        }}
                      />
                      {optIdx === field?.options?.length - 1 && (
                        <Button
                          buttonLabel=""
                          buttonIconPosition="left"
                          buttonIcon="fa-solid fa-plus"
                          buttonType="button"
                          buttonClasses="!bg-blue-500 !text-white !text-sm !rounded !px-3 !py-1"
                          buttonFunction={() =>
                            handleFieldChange(i, "options", [
                              ...(field.options || []),
                              "",
                            ])
                          }
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
              {field.fieldType === "File" && (
                <div className="mt-4 w-full flex flex-wrap md:flex-nowrap items-start gap-4">
                  <div className="flex-none">
                    <Button
                      buttonLabel="Upload"
                      buttonType="button"
                      buttonClasses="!bg-blue-600 !text-white !rounded !px-6 !py-2"
                      buttonFunction={() => handleUploadClick(i)}
                    />
                  </div>

                  {(showUploadInputs?.includes(i) ||
                    (field?.file && field?.uploadButtonText)) && (
                    <>
                      <div className="w-full md:w-1/3">
                        <FileUploadSingle
                          size="small"
                          label="Upload Cover Image"
                          value={field.file}
                          onChange={(file) =>
                            handleFieldChange(i, "file", file)
                          }
                          accept=".jpg,.jpeg,.png,.pdf,.webp"
                        />
                      </div>
                      <div className="w-full md:w-1/3 mt-1 md:mt-4">
                        <Input
                          label="Upload Button Text"
                          placeholder="Enter placeholder"
                          value={field.uploadButtonText}
                          onChange={(e) =>
                            handleFieldChange(
                              i,
                              "uploadButtonText",
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          ))}

          <div className="mt-4">
            {addingField && (
              <div className="w-full md:w-1/4">
                <Select
                  label="Select Field Type"
                  placeholder="Select type"
                  selectedValue={newFieldType}
                  dropdownData={[
                    { name: "Input", value: "Input" },
                    { name: "Email", value: "Email" },
                    { name: "TextArea", value: "TextArea" },
                    { name: "InputNumber", value: "InputNumber" },
                    { name: "Url", value: "Url" },
                    { name: "DatePicker", value: "DatePicker" },
                    { name: "Select", value: "Select" },
                    { name: "Radio", value: "Radio" },
                    { name: "File", value: "File" },
                    { name: "Checkbox", value: "Checkbox" },
                  ]}
                  setSelectedValue={(val) => {
                    setNewFieldType(val);
                    handleAddField(val);
                    setAddingField(false);
                  }}
                />
              </div>
            )}
            <div className="mt-4 flex gap-4 items-center">
              <Button
                buttonType="button"
                buttonLabel="Add Field"
                buttonIcon={"fa-solid fa-plus"}
                buttonIconPosition={"left"}
                buttonClasses="!rounded-full !px-6 !h-10 !bg-chestnut-rose !text-white"
                buttonFunction={() => setAddingField(true)}
              />
              <Button
                buttonType="button"
                buttonLabel={"Back"}
                buttonClasses={
                  "!rounded-full !px-6 !h-10 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
                }
                buttonLabelClasses={"mx-auto"}
                buttonFunction={backHandeler}
              />
              <Button
                buttonType="button"
                buttonLabel="Continue"
                buttonClasses="!rounded-full !px-6 !h-10 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
                buttonLabelClasses="mx-auto text-sm"
                buttonFunction={continueHandler}
              />
            </div>
          </div>
          <DeleteModal
            open={deleteModal?.isOpen}
            loading={deletePending}
            onClose={() =>
              setDeleteModal((pre) => ({ data: null, isOpen: false }))
            }
            customMessage={"Are you sure you want to delete this field."}
            deleteHandler={() => {
              if (deleteModal?.data) {
                handleDeleteApi(deleteModal?.data);
              }
            }}
          />
        </div>
      ) : (
        <div>Loading .....</div>
      )}
    </>
  );
};

export default SchoolPaymentInfo;
